import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Crumb } from '../../../core/models/crumb';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../../base/reducers';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadcrumbsComponent {
  @Input('static') staticCrumbs: Crumb[] = []
  @Input() crumbs: Crumb[] = []
  @Input() prefix: string
  @Input() onlyStatic: boolean = false

  fullWidthView$: Observable<any>

  constructor(private store: Store<any>) {
    this.fullWidthView$ = store
      .pipe(
        select(fromBase.isFullWidthViewEnabled)
      )
  }

  get prefixUrl() {
    if(!this.prefix)
      return '/'

    return '/' + (this.prefix + '/').replace(/\//g, '') + '/'
  }

  get hasCrumbs(): boolean {
    return (this.crumbs && (this.crumbs.length > 1))
      || (this.staticCrumbs && (this.staticCrumbs.length > 1))
  }

  crumbLink(targetIndex) {
    return this.crumbs.reduce(
      (prev, curr, idx, arr) =>  {
        if(idx <= targetIndex)
          return prev + curr.slug + '/'
        return prev
      },
      this.prefixUrl
    )
  }
}
